export default __webpack_public_path__ + "static/media/santa_snowdown_3.d51021bd.png";